module.exports = __webpack_public_path__ + "img/growth.9764c3ee.png";